var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { ReleaseListPage } from '@/pages/release/ReleaseList/ReleaseListPage';
import { useReleaseListFetch } from '@/pages/release/ReleaseList/useReleaseListFetch';
import { parseQuery, getParsedQueryString, } from '@/utils/libs/query-string/parse';
/**
 * ニュース一覧（データ取得, 認証以外のアクセス制限）
 * @param props
 * @returns
 */
export const ReleaseList = () => {
    const { search } = useLocation();
    const query = parseQuery(search);
    const page = parseInt(getParsedQueryString(query.page), 10) || 1;
    const { fetchReleaseList, loading, onChangePage, releaseList } = useReleaseListFetch();
    useEffect(() => {
        // 初期データ取得
        if (!(releaseList === null || releaseList === void 0 ? void 0 : releaseList[page])) {
            ;
            (() => __awaiter(void 0, void 0, void 0, function* () {
                yield fetchReleaseList(page);
            }))();
        }
    }, [fetchReleaseList, page, releaseList]);
    // 表示中のデータ
    const currentPageData = releaseList === null || releaseList === void 0 ? void 0 : releaseList[page];
    return (_jsx(ReleaseListPage, { currentPage: currentPageData === null || currentPageData === void 0 ? void 0 : currentPageData.pagination.current_page, loading: loading, onChangePage: onChangePage, releaseList: currentPageData === null || currentPageData === void 0 ? void 0 : currentPageData.list, totalPageCount: currentPageData === null || currentPageData === void 0 ? void 0 : currentPageData.pagination.total_page }));
};
